import React, { useState } from "react";
import { useToast } from "@/hooks/useToast";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useMutation } from "react-query";
import { programme } from "@/queries";
import { FormDataProvider } from "@/base/form/data-context/FormDataContext";
import { Button, Stack } from "@mui/material";
import { FormRichTextField } from "@/base/form/mui/FormRichTextField";

export const TargetForm = ({ programmeData, onUpdate, t }) => {
  const [isEditing, setIsEditing] = useState(false);
  const toast = useToast();
  const schema = yup.object().shape({
    target: yup.string().optional(),
  });

  const formData = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      target: programmeData?.target || "",
    },
  });

  const { handleSubmit, reset } = formData;

  const updateTarget = useMutation(programme.editTarget, {
    onSuccess: (data) => {
      console.log("Received data: " + JSON.stringify(data));
      toast.success(
        data?.message ?? "Target operation model successfully edited",
      );
      onUpdate?.();
      setIsEditing(false);
    },

    onError: (error) => {
      console.error(
        `Received error: ${error?.message ?? "-"} ${
          error?.response?.data?.message ?? "-"
        }`,
      );
      toast.error(
        `Error editing Target operation model. ${error?.response?.data?.message}`,
      );
    },
  });

  return (
    <FormDataProvider formKey="programme.editDesignForm.fields" {...formData}>
      <form
        onSubmit={handleSubmit((data) => {
          updateTarget.mutate({
            id: programmeData.id,
            data: {
              target: data.target,
            },
          });
        })}
      >
        <Stack spacing={3}>
          <FormRichTextField
            name="target"
            readOnly={!isEditing}
            editable={!isEditing}
            onEditClick={() => setIsEditing(true)}
            labelStyle={{ fontWeight: "700", lineHeight: "24px" }}
          />
          {isEditing && (
            <Stack
              direction="row"
              spacing={2}
              justifyContent="flex-end"
              sx={{ width: "100%", mt: 2 }}
            >
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setIsEditing(false)}
              >
                {t("generic.button.cancel")}
              </Button>
              <Button type="submit" variant="contained">
                {t("generic.button.save")}
              </Button>
            </Stack>
          )}
        </Stack>
      </form>
    </FormDataProvider>
  );
};
